export default "__VITE_ASSET__CptdFS_K__"